import React from 'react';

import  Token  from './token';

export const ValueTokenRenderer = ({
                              value,
                              valueClassName,
                              disabled,
                              removable,
                              onRemove,
                            }) => {
  if (!value) return null;
  if (Array.isArray(value)) {
    return value && value.length > 0 &&
      value.map(selection => (
        <Token
          disabled={disabled}
          className={valueClassName}
          key={selection.label}
          removable={removable}
          onRemove={(removable && !disabled) ? onRemove(selection) : undefined}
        >
          {selection.label}
        </Token>
      ));
  }
  return value && (
    <Token
      disabled={disabled}
      className={valueClassName}
      key={value.label}
      removable={removable}
      onRemove={(removable && !disabled) ? onRemove(value) : undefined}
    >
      {value.label}
    </Token>
  );
};

